import React from "react";
import {Card} from "react-bootstrap";
import RulesEditDistanceGS from "./RulesEditDistanceGS";
import RulesEditStructLength from "./RulesEditStructLength";
import RulesEditVolume from "./RulesEditVolume";
import RulesEditOverlap from "./RulesEditOverlap";
import { useHistogram } from "./RulesContext";

export default function RulesListExpandedElement(props) {
    const { getHistogramForOrgans } = useHistogram();

    function cbGS(val) {
        props.callback(props.data);
    }

    function cbSL(val) {
        props.data.lengthRules = val;
        props.callback(props.data);
    }

    function cbVL(val) {
        props.data.volumeRules = val;
        props.callback(props.data);
    }

    function cbOL(val) {
        props.data.dist2OtherRules = val;
        props.callback(props.data);
    }

    function containsRuleType(ruletype) {
        for (let i = 0; i < props.data.length; i++) {
            if(props.data[i].ruleType === ruletype)
                return true;
        }
        return false;
    }

    return (
        <Card.Body>
            {containsRuleType('struct2GSrules') &&
            <RulesEditDistanceGS
                data={props.data}
                cb={cbGS}
                getHistogramData={getHistogramForOrgans}
            />
            }
            {containsRuleType('lengthRules') &&
            <RulesEditStructLength
                data={props.data}
                cb={cbSL}
            />
            }
            {containsRuleType('volumeRules') &&
            <RulesEditVolume
                data={props.data}
                cb={cbVL}
            />
            }
            {containsRuleType('dist2OtherRules') &&
            <RulesEditOverlap
                otherStructs={props.otherStructs}
                data={props.data}
                cb={cbOL}
            />
            }
        </Card.Body>
    );
}